import React from "react";
import { useTheme } from "../../../../hooks/useTheme";
import Icon from "../../../icon/Icon";
import { ModalHeaderDiv } from "./ModalHeaderStyles";
const ModalHeader = ({ children, styles = {}, close }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.modal.header, ...styles };
    const IconStylesOverride = { ...Theme.icon };
    if (StylesOverride.iconSize) {
        IconStylesOverride.size = styles.iconSize;
    }
    const closeIcon = StylesOverride.closeIcon ?? "fa-times-circle";
    return (React.createElement(ModalHeaderDiv, { styles: StylesOverride },
        children,
        " ",
        !!close && React.createElement(Icon, { iconName: closeIcon, onClick: close, styles: IconStylesOverride })));
};
ModalHeader.displayName = "ModalHeader";
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map